var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.069,
    height: 16,
    viewBox: "0 0 22.069 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14350",
    "data-name": "Path 14350",
    d: "M168,142.345a.826.826,0,0,0,.828-.828v-.552a3.588,3.588,0,0,1,3.586-3.586h1.655a3.588,3.588,0,0,1,3.586,3.586v.552a.826.826,0,0,0,.828.828Zm7.448-12.138A2.207,2.207,0,1,1,173.241,128,2.209,2.209,0,0,1,175.448,130.207Z",
    transform: "translate(-162.207 -46.345)",
    fill: "#1da1f2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14351",
    "data-name": "Path 14351",
    d: "M11.034,86.069a2.207,2.207,0,1,0-2.207-2.207A2.209,2.209,0,0,0,11.034,86.069Zm0-6.069a3.862,3.862,0,1,1-3.862,3.862A3.86,3.86,0,0,1,11.034,80Zm-.828,11.034a3.588,3.588,0,0,0-3.586,3.586v.552a.828.828,0,1,1-1.655,0v-.552a5.243,5.243,0,0,1,5.241-5.241h1.655A5.243,5.243,0,0,1,17.1,94.621v.552a.828.828,0,1,1-1.655,0v-.552a3.588,3.588,0,0,0-3.586-3.586Zm4.669-3.214a5.5,5.5,0,0,0,1.014-1.338,1.637,1.637,0,0,0,.662.138,1.655,1.655,0,1,0,0-3.31h-.028a5.441,5.441,0,0,0-.417-1.624,3.178,3.178,0,0,1,.445-.031,3.31,3.31,0,1,1-1.676,6.166ZM5.517,81.655a3.142,3.142,0,0,1,.445.031,5.468,5.468,0,0,0-.417,1.624H5.517a1.655,1.655,0,1,0,0,3.31,1.637,1.637,0,0,0,.662-.138,5.5,5.5,0,0,0,1.014,1.338,3.31,3.31,0,1,1-1.676-6.166Zm-.369,8.276A6.865,6.865,0,0,0,3.89,91.848a3.589,3.589,0,0,0-2.234,3.324.828.828,0,1,1-1.655,0A5.24,5.24,0,0,1,5.148,89.931Zm13.031,1.917a6.891,6.891,0,0,0-1.259-1.917,5.24,5.24,0,0,1,5.148,5.241.828.828,0,1,1-1.655,0A3.589,3.589,0,0,0,18.179,91.848Z",
    fill: "#1da1f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsearch);
export default __webpack_public_path__ + "static/media/socialsearch.e3f02bb7fbdf8e73f70681994aa43459.svg";
export { ForwardRef as ReactComponent };